import { useState, useCallback } from 'react';

export const useDragAndDrop = (isDragEnabled, reorderCables) => {
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);

  const handleDragStart = useCallback((e, index) => {
    if (!isDragEnabled) return;

    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', index.toString());

    setTimeout(() => {
      e.target.style.opacity = '0.5';
    }, 0);
  }, [isDragEnabled]);

  const handleDragEnd = useCallback((e) => {
    e.target.style.opacity = '1';
    setDraggedIndex(null);
    setDragOverIndex(null);
  }, []);

  const handleDragOver = useCallback((e, index) => {
    if (!isDragEnabled || draggedIndex === null) return;

    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'move';

    if (index !== draggedIndex) {
      setDragOverIndex(index);
    }
  }, [isDragEnabled, draggedIndex]);

  const handleDragEnter = useCallback((e, index) => {
    if (!isDragEnabled || draggedIndex === null) return;

    e.preventDefault();
    setDragOverIndex(index);
  }, [isDragEnabled, draggedIndex]);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
  }, []);

  const handleDrop = useCallback((e, dropIndex) => {
    e.preventDefault();
    e.stopPropagation();

    if (draggedIndex !== null && draggedIndex !== dropIndex) {
      reorderCables(draggedIndex, dropIndex);
    }

    setDraggedIndex(null);
    setDragOverIndex(null);
  }, [draggedIndex, reorderCables]);

  return {
    draggedIndex,
    dragOverIndex,
    handleDragStart,
    handleDragEnd,
    handleDragOver,
    handleDragEnter,
    handleDragLeave,
    handleDrop,
    setDraggedIndex,
    setDragOverIndex,
  };
};
